import React, {useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import Preloader from "../Include/PreLoader";
import AIBackground from "../../functions/AIBackground";
import PandaPickLogo from "../../assets/icon.png";

import {handleCheckOut} from "../../functions/TrackingEmployeeFunctions";

import useTrackingEmployee from '../../hooks/useTrackingEmployee';


const TrackingEmployee = () => {

    const [loading, setLoading] = useState(false);

const navigate = useNavigate();

    const {
    empauth,
    checkedOut,
    workingTime,
    loginTime,
    distancef,
    setCheckedOut
} = useTrackingEmployee();



    return (

         <div className='hero-section'>
            <AIBackground />

        <div className="container">

            <div className="row justify-content-center g-4">
    <div className="text-center">
    <img  src={PandaPickLogo}  alt="PandaPick" className='img-fluid brand_logo'/>
    </div>
</div>

            <div className="row justify-content-center g-4 py-4">

                <div className="col-lg-3 text-center">


                   {loading ? (
                <Preloader show={loading} />
            ) : (
                <>

                    <h2 className='text-white fw-light'>
                        Welcome 
                        <small className='fw-bold'>
                        {" "}
                        {empauth
                            ? JSON.parse(empauth).name
                            : ""}
                        </small>
                    </h2>

                    {empauth ? (
                        <>
                            <div className="text-center text-white">

                                <h5 className='fw-light'>
                                    Today's Working Time
                                </h5>

                                <h1>
                                    {workingTime}
                                </h1>

                                <p>
                                    Latest Login Time:{" "}
                                    {loginTime
                                        ? new Date(
                                            loginTime
                                        ).toLocaleTimeString("en-IN")
                                        : "--:--:--"}
                                </p>

                                <p>
                                    {distancef}
                                </p>

                            </div>

                           <button
    onClick={() => {
        setLoading(true);

        handleCheckOut(
            setCheckedOut,
            navigate,
            setLoading
        );
    }}
    className="btn-start-free"
    disabled={checkedOut}
>
                                {checkedOut
                                    ? "Checked Out"
                                    : "CheckOut"}
                            </button>
                        </>
                    ) : (
                        <Link
                            className="btn-start-free"
                            to="/mark-attendance"
                        >
                            Mark Attendance
                        </Link>
                    )}

                  </>
            )}

                </div>



            </div>

        </div>

        </div>
    );
};

export default TrackingEmployee;